import React, { useState } from 'react';
import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import IconChevronDown from '@zvuk-b2b/react-uikit/ui/icons/ChevronDown';
import IconChevronUp from '@zvuk-b2b/react-uikit/ui/icons/ChevronUp';
import { CollapsibleSectionProps } from './types';
import { DATA_TEST_IDS } from '../consts';
import styles from './index.module.scss';

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div
      className={styles.panel}
      data-testid={DATA_TEST_IDS.EXAMPLE_PANEL}>
      <Button
        type={ButtonType.PLAIN}
        className={styles.title}
        elementId={DATA_TEST_IDS.EXAMPLE_TOGGLE}
        onClick={() => setIsOpen((value) => !value)}>
        {title}
        {isOpen ? <IconChevronUp className={styles.chevron} /> : <IconChevronDown className={styles.chevron} />}
      </Button>
      {isOpen && (
        <div
          id={DATA_TEST_IDS.EXAMPLE_CONTENT}
          data-testid={DATA_TEST_IDS.EXAMPLE_CONTENT}
          className={styles.content}>
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
